import differenceInDays from 'date-fns/differenceInDays';
import { chooseVariant } from 'reactApp/modules/features/features.helpers';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { FileType } from 'reactApp/types/FileType';

interface Params {
    isFolder?: boolean;
    ext?: string /* TODO: нужно менять тип на FileType */;
    kind?: string;
    isVirus?: boolean;
    isAutoDelete?: boolean;
    ignoreFolderType?: boolean;
    publicExpires?: number;
}

export const getIconType = ({ isFolder, ext, kind, isVirus, isAutoDelete, ignoreFolderType, publicExpires }: Params): FileType => {
    if (isVirus) {
        return FileType.VIRUS;
    }

    if (isFolder) {
        if (ignoreFolderType) {
            return FileType.FOLDER;
        }

        if (isAutoDelete) {
            if (typeof publicExpires === 'number') {
                const now = Date.now();
                const daysDifference = differenceInDays(new Date(publicExpires), now);

                const lessThanMonthLeft = daysDifference < 30;
                const lessThanWeekLeft = daysDifference < 7;

                // tempexp_14728-next-line
                if (chooseVariant(getFeatureNewContentGrid, { control: false, variant1: lessThanWeekLeft })()) {
                    return FileType.FOLDER_AUTODELETE_WEEK;
                }

                // tempexp_14728-next-line
                if (chooseVariant(getFeatureNewContentGrid, { control: false, variant1: lessThanMonthLeft })()) {
                    return FileType.FOLDER_AUTODELETE_MONTH;
                }
            }

            return FileType.FOLDER_AUTODELETE;
        }

        if (kind === 'shared') {
            return FileType.FOLDER_SHARED;
        }

        if (kind === 'mounted' || kind === 'domain-folder') {
            return FileType.FOLDER_MOUNTED;
        }

        if (kind === 'camera-upload') {
            return FileType.FOLDER_CAMERA;
        }

        return FileType.FOLDER;
    }

    return (ext as FileType) /* TODO: нужно менять тип на FileType */ || FileType.UNKNOWN;
};
